<script>
import JobForm from './JobForm'

export default {
  name: 'PageJobAdd',

  components: {
    JobForm
  }
}
</script>

<template>
  <section class="hero is-primary">
    <div class="container">
      <h1 class="title is-2">Ajouter un Emploi</h1>

      <job-form/>
    </div>
  </section>
</template>

<style scoped>
.container {
  max-width: 640px;
}

.hero {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/PageJobAdd.vue